import { Schemas } from '../types/api-types';
import apiClient from '../clients/apiClient';

export type RepaymentScheduleItemResponse = Schemas['PlLoanAmotResponse'];

export const fetchRepaymentSchedule = async (plAccountId: number) => {
    const response = await apiClient.get(`/loan-application/repayment-schedule/${plAccountId}`);
    return response.data.data || [];
};

export const updateOpenDate = async (applicationId: number, openDate: string) => {
    const response = await apiClient.put(`/loan-application/open_date/${applicationId}`, { open_date: openDate });
    return response.data.data;
};
